import { protectedLoader } from './protectLoader'
import { LoaderFunctionArgs } from 'react-router-dom'
import {
  CUSTOMER_ADMIN,
  CUSTOMER_SUPPORT,
  DISTRIBUTOR_ADMIN,
  DISTRIBUTOR_SUPPORT,
  HOLDER,
  LIVOX_USER,
  PORTAL_ADMIN,
  PORTAL_SUPPORT,
  SPONSOR,
} from '.'
import { lazyRoute } from '../utils/lazyRoute'

const cloudStoreRoutes = [
  {
    path: '/v1/store/user-boards/:customer_uid',
    lazy: lazyRoute(() => import('../pages/Studio/UserBoards'), 'UserBoards'),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
  {
    path: '/v1/store/admin/statistics',
    lazy: lazyRoute(() => import('../pages/Store/StoreAdmin/Statistics')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/v1/store/admin/pending',
    lazy: lazyRoute(() => import('../pages/Store/StoreAdmin/Pending')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/v1/store/admin/promoted',
    lazy: lazyRoute(() => import('../pages/Store/StoreAdmin/Promoted')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/v1/store/admin/boards',
    lazy: lazyRoute(() => import('../pages/Store/StoreAdmin/Manage')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/v2/studio/board/:id/*',
    lazy: lazyRoute(() => import('../pages/Studio/BoardStudio')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          SPONSOR,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
        ],
      }),
  },
  {
    path: '/v2/studio/tablet-board/:licenseKey/:livoxUserUuid/:boardId/*',
    lazy: lazyRoute(
      () => import('../pages/Studio/BoardStudio/TabletBoardStudio'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          SPONSOR,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
        ],
      }),
  },
  {
    path: '/v2/store',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront')),
  },
  {
    path: '/v2/store/my-boards',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront/MyBoards')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          SPONSOR,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
        ],
      }),
  },
  {
    path: '/v2/store/my-boards/portal',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront/MyBoardsPortal')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          SPONSOR,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
        ],
      }),
  },
  {
    path: '/v2/store/my-boards/:licenseKey',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront/MyBoardsLicense')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          SPONSOR,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
        ],
      }),
  },
  {
    path: '/v2/store/my-boards/:licenseKey/:livoxUserUuid',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront/MyBoardsTablet')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          SPONSOR,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
          LIVOX_USER,
        ],
      }),
  },
  {
    path: '/v2/store/board/:id',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront/BoardDetail')),
  },
  {
    path: '/v2/store/profile/:slug/:authorId',
    lazy: lazyRoute(() => import('../pages/Store/StoreFront/Profile')),
  },
]

export default cloudStoreRoutes
